module["exports"] = [
  "Taiwan (R.O.C.)"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/default_country.js
// module id = 1489
// module chunks = 0